import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';

const dividerSpacing = {
  none: '0',
  default: space['space-400'],
  large: space['space-800'],
};

export const Wrapper = styled.div<{ $spacing?: 'none' | 'default' | 'large' }>`
  display: flex;
  align-items: center;
  gap: ${space['space-300']};
  padding: ${(p) => dividerSpacing[p.$spacing ?? 'default']} 0;
`;

export const Line = styled.div`
  flex: 1;
  height: ${size.stroke['stroke-default']};
  background: ${semantic.border.default};
`;

export const Text = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.secondary};
  flex-shrink: 0;
`;
